import {
    adminAttestRoutes, adminAttestRoutesPrimary,
    adminDigitalAccountRoutes,
    adminHonorariumCreateRoutes,
    adminHonorariumViewRoutes,
    adminInternalTransactionRoutes,
    adminInvoiceRoutes,
    adminOrgViewRoutes,
    adminReportTaxtAuthorityRoutes,
    adminRoleRoutes,
    adminSalaraySheetRoutes,
    adminSieRoutes,
    adminTransferRoutes,
    adminUserRoutes, collectRoutes,
    digitalAccountRoutes,
    invoiceCreate,
    invoiceView,
    orgRoutes,
    payRoutes,
    publicRoutes,
    QRcodeCreate,
    QRcodeView,
    quickPaymentRoutes,
    reimbursementCreateRoutes,
    reimbursementViewRoutes, reportsRoutes,
    salarySheet,
    transactionRoutes,
    userRoutes,
    orgAttest,
    adminEconomicReportRoutes,
    adminEconomicReportInfoRoutes,
    organizationEconomicReportInfoRoutes,
    adminCostBearerRoutes,
    adminGuideListRoutes,
    adminAccountingRoutes,
    adminApiKeyRoutes,
    settingsRoutes,
    adminSwedBankReportRoutes,
    orgDetailsRoutes,
    adminCalendarActivityRoutes,
    adminEconomicRoutes,
    adminInvoiceAccountsRoutes
} from '../../routes';
import { useSelector } from "react-redux";
import { CheckUserPermission } from "../Helpers/CheckUserPermission";
import { useTranslation } from "react-i18next";
import { CheckUserRole } from "../Helpers/CheckUserRole";
import { CheckUserOrganization } from "../Helpers/CheckUserOrganization";
import { useTimer } from "../../Common/Helpers/CalculateTimeRemaining";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import useApiCallService from "../../Common/Helpers/ApiCall";
import { useMsal } from "@azure/msal-react";

import { CustomReload } from "../Helpers/CustomReload";
import { ADMIN_PATHS, PUBLIC_PATHS } from "../../config";
import { redirectWhenCloseSession } from "../../Common/Helpers/RedirectWhenCloseSession";
import { CheckOrgTypePermission } from "../Helpers/CheckOrgTypePermission";
import { hasPermission } from "../Helpers/hasPermission";
import { hasOrgTypePermission } from "../Helpers/hasOrgTypePermission";

// DEFINE ROUTES
export function useRoutes() {
    const { tokenData, refreshTokenData, isAuthenticated, orgData, userData, rolesData } = useSelector(state => state.auth);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { instance, accounts } = useMsal();
    // DEFAULT ROUTES: PUBLIC ROUTES
    let routes = publicRoutes;
    // let subs = collectRoutes[0].subs;
//     const authChannel = new BroadcastChannel("auth-channel");
//     authChannel.onmessage = (message) => {
//         if (message.data.action === "logout") {
//             if (!isAuthenticated || !tokenData || !refreshTokenData) {
//                 redirectWhenCloseSession(tokenData);
//             }
//         }
//     };
//     const activeAccount = instance.getActiveAccount() || accounts[0];
//     useTimer(refreshTokenData?.expires,tokenData,dispatch,instance,activeAccount);

  // GET USER COST PLACES
  const [apiResponseUserCostPlaceList, setApiResponseUserCostPlaceList] =
    useState(null);
  const { ApiCall } = useApiCallService();
  useEffect(() => {
    const handleUserCostPlaceList = (response) => {
      setApiResponseUserCostPlaceList(response);
    };
    const GetUserCostPlaceList = async () => {
      if (userData?.id) {
        try {
          const apiCallOptions = {
            method: "get",
            url: "/usersetting/primary-costplace?id=" + userData?.id,
          };
          await ApiCall(apiCallOptions, handleUserCostPlaceList);
        } catch (error) {
          console.log("error", error);
        }
      }
    };
    GetUserCostPlaceList();
  }, [userData]);

  // IS AUTHENTICATED
  if (isAuthenticated === true) {
    // REPLACE DEFAULT ROUTES FOR USER ROUTES
    routes = userRoutes;

    //// USER
    // REIMBURSEMENT
    let reimbursementRoutes = [];
    if (
      hasPermission(rolesData, "user") ||
      hasPermission(rolesData, "user.reimbursement") ||
      (hasPermission(rolesData, "user.reimbursement.create") &&
        hasPermission(rolesData, "user.reimbursement.view"))
    ) {
      // Crea un *nuevo* objeto con hideInMenu: true
      const createRoute = { ...reimbursementCreateRoutes[0], hideInMenu: true };
      // Crea un *nuevo* array combinando el original con la nueva ruta
      const viewRoute = [...reimbursementViewRoutes, createRoute];
      reimbursementRoutes = [...reimbursementRoutes, ...viewRoute];
    } else if (
      hasPermission(rolesData, "user.reimbursement.create") &&
      !hasPermission(rolesData, "user.reimbursement.view")
    ) {
      reimbursementRoutes = [
        ...reimbursementRoutes,
        ...reimbursementCreateRoutes,
      ];
    } else if (
      hasPermission(rolesData, "user.reimbursement.view") &&
      hasPermission(rolesData, "user.reimbursement.create")
    ) {
      const createRoute = { ...reimbursementCreateRoutes[0], hideInMenu: true };
      const viewRoute = [...reimbursementViewRoutes, createRoute];
      reimbursementRoutes = [...reimbursementRoutes, ...viewRoute];
    } else if (
      hasPermission(rolesData, "user.reimbursement.view") &&
      !hasPermission(rolesData, "user.reimbursement.create")
    ) {
      reimbursementRoutes = [
        ...reimbursementRoutes,
        ...reimbursementViewRoutes,
      ];
    }

    if (reimbursementRoutes.length > 0) {
      reimbursementRoutes[0].title = "modelLabel.forYou";
      routes = [...routes, ...reimbursementRoutes];
    }

    // SALARYSHEET
    if (
      hasPermission(rolesData, "user") ||
      hasPermission(rolesData, "user.salary-sheet") ||
      hasPermission(rolesData, "user.salary-sheet.view")
    ) {
      routes = [...routes, ...salarySheet];
    }

    //// ORG
    if (CheckUserOrganization(orgData)) {
      let orgRoutesArray = [];
      // ACCOUNT
      if (
        hasPermission(rolesData, "org") ||
        hasOrgTypePermission(orgData, "org.account") ||
        hasOrgTypePermission(orgData, "org.account.view")
      ) {
        if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.account") ||
          hasPermission(rolesData, "org.account.view")
        ) {
          orgRoutesArray = [...orgRoutesArray, ...digitalAccountRoutes];
        }
      }

      // PAY
      if (
        hasPermission(rolesData, "org") ||
        hasOrgTypePermission(orgData, "org.pay") ||
        hasOrgTypePermission(orgData, "org.pay.create") ||
        hasOrgTypePermission(orgData, "org.pay.view")
      ) {
        if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.pay") ||
          hasPermission(rolesData, "org.pay.create") ||
          hasPermission(rolesData, "org.pay.view")
        ) {
          orgRoutesArray = [...orgRoutesArray, ...payRoutes];
        }
      }
      //// COLLECT
      // Crea una copia profunda para evitar mutar el original
      let collectR = structuredClone(collectRoutes);
      // QUICKPAYMENT
      if (
        hasPermission(rolesData, "org") ||
        hasPermission(rolesData, "org.collect.quick-pay") ||
        hasOrgTypePermission(orgData, "org.collect") ||
        hasOrgTypePermission(orgData, "org.collect.quick-pay") ||
        hasOrgTypePermission(orgData, "org.collect.quick-pay.view") ||
        hasOrgTypePermission(orgData, "org.collect.quick-pay.create")
      ) {
        if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.collect") ||
          hasPermission(rolesData, "org.collect.quick-pay") ||
          (hasPermission(rolesData, "org.collect.quick-pay.view") &&
            hasPermission(rolesData, "org.collect.quick-pay.create"))
        ) {
          collectR[0].subs.push(...quickPaymentRoutes[0].subs);
          collectR.push(quickPaymentRoutes[1]);
          collectR.push(quickPaymentRoutes[2]);
          collectR.push(quickPaymentRoutes[3]);
        } else if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.collect.quick-pay") ||
          hasPermission(rolesData, "org.collect.quick-pay.view")
        ) {
          collectR[0].subs.push(...quickPaymentRoutes[0].subs);
          collectR.push(quickPaymentRoutes[1]);
          collectR.push(quickPaymentRoutes[3]);
        }
      }

      // ORG-QR
      if (
        hasPermission(rolesData, "org") ||
        hasOrgTypePermission(orgData, "org.collect") ||
        hasOrgTypePermission(orgData, "org.collect.qr-pay") ||
        hasOrgTypePermission(orgData, "org.collect.qr-pay.create") ||
        hasOrgTypePermission(orgData, "org.collect.qr-pay.view") ||
        hasOrgTypePermission(orgData, "org.collect.qr-pay.update")
      ) {
        if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.collect") ||
          hasPermission(rolesData, "org.collect.qr-pay") ||
          (hasPermission(rolesData, "org.collect.qr-pay.create") &&
            hasPermission(rolesData, "org.collect.qr-pay.view") &&
            hasPermission(rolesData, "org.collect.qr-pay.update"))
        ) {
          collectR[0].subs.push(...QRcodeView[0].subs);
          collectR.push(QRcodeView[1]);
          collectR.push(QRcodeView[2]);
          collectR.push(QRcodeCreate[0]);
        } else if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.collect") ||
          hasPermission(rolesData, "org.collect.qr-pay.view")
        ) {
          collectR[0].subs.push(...QRcodeView[0].subs);
          collectR.push(QRcodeView[1]);
          collectR.push(QRcodeView[2]);
        }
      }

      // INVOICE
      if (
        hasPermission(rolesData, "org") ||
        hasOrgTypePermission(orgData, "org.collect") ||
        hasOrgTypePermission(orgData, "org.collect.invoice") ||
        hasOrgTypePermission(orgData, "org.collect.invoice.create") ||
        hasOrgTypePermission(orgData, "org.collect.invoice.view") ||
        hasOrgTypePermission(orgData, "org.collect.invoice.update")
      ) {
        if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.collect") ||
          hasPermission(rolesData, "org.collect.invoice") ||
          (hasPermission(rolesData, "org.collect.invoice.create") &&
            hasPermission(rolesData, "org.collect.invoice.view") &&
            hasPermission(rolesData, "org.collect.invoice.update"))
        ) {
          collectR[0].subs.push(...invoiceView[0].subs);
          collectR.push(invoiceView[1]);
          collectR.push(invoiceCreate[0]);
          collectR.push(invoiceCreate[1]);
        } else if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.collect") ||
          hasPermission(rolesData, "org.collect.invoice.view")
        ) {
          collectR[0].subs.push(...invoiceView[0].subs);
          collectR.push(invoiceView[1]);
        }
      }

      const uniqueSubs = collectR[0].subs.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.path === value.path &&
              t.label === value.label &&
              t.component === value.component &&
              t.hideInMenu === value.hideInMenu,
          ),
      );
      collectR[0].subs = uniqueSubs;

      const uniqueArray = collectR.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              t.path === value.path &&
              t.component === value.component &&
              t.hideInMenu === value.hideInMenu,
          ),
      );

      collectR = uniqueArray;
      if (collectR.length > 0) {
        orgRoutesArray = [...orgRoutesArray, ...collectR];
      }

      // ORG
      if (
        hasPermission(rolesData, "org") ||
        hasPermission(rolesData, "org.user") ||
        hasPermission(rolesData, "org.user.view")
      ) {
        orgRoutesArray = [...orgRoutesArray, ...orgRoutes];
      }

      // ORG Details
      if (
        hasPermission(rolesData, "org") ||
        hasPermission(rolesData, "org.info") ||
        hasPermission(rolesData, "org.info.view")
      ) {
        orgRoutesArray = [...orgRoutesArray, ...orgDetailsRoutes];
      }

      if (
        hasPermission(rolesData, "org") ||
        hasPermission(rolesData, "org.economic-report") ||
        hasPermission(rolesData, "org.economic-report.view")
      ) {
        orgRoutesArray = [
          ...orgRoutesArray,
          ...organizationEconomicReportInfoRoutes,
        ];
      }

      // ORG ATTEST
      if (
        hasPermission(rolesData, "org") ||
        hasOrgTypePermission(orgData, "org.attest") ||
        hasOrgTypePermission(orgData, "org.attest.view")
      ) {
        if (
          hasPermission(rolesData, "org") ||
          hasPermission(rolesData, "org.attest") ||
          hasPermission(rolesData, "org.attest.view")
        ) {
          orgRoutesArray = [...orgRoutesArray, ...orgAttest];
        }
      }

      if (orgRoutesArray.length > 0) {
        orgRoutesArray[0].title = "modelLabel.forYourOrganization";
        routes = [...routes, ...orgRoutesArray];
      }
    }

    // CHECK ADMIN ROLE
    let adminRoutes = [];

    // ATTEST
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.attest") ||
      hasPermission(rolesData, "admin.attest.view")
    ) {
      if (
        apiResponseUserCostPlaceList &&
        apiResponseUserCostPlaceList.primaryCostPlaces
      ) {
        adminRoutes = [...adminRoutes, ...adminAttestRoutesPrimary];
      } else {
        adminRoutes = [...adminRoutes, ...adminAttestRoutes];
      }
    }

    // DIGITAL ACCOUNT
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.account") ||
      hasPermission(rolesData, "admin.account.view")
    ) {
      adminRoutes = [...adminRoutes, ...adminDigitalAccountRoutes];
    }

    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.reports.economic-report")
    ) {
      adminRoutes = [...adminRoutes, ...adminEconomicReportInfoRoutes];
    }

    // INTERNAL TRANSACTION
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.internal-transaction") ||
      hasPermission(rolesData, "admin.internal-transaction.create")
    ) {
      adminRoutes = [...adminRoutes, ...adminInternalTransactionRoutes];
    }

    // TRANSACTIONS
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.open-payment") ||
      hasPermission(rolesData, "admin.open-payment.view")
    ) {
      adminRoutes = [...adminRoutes, ...adminTransferRoutes];
    }

    // INVOICE
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.invoice") ||
      hasPermission(rolesData, "admin.invoice.view")
    ) {
      adminRoutes = [...adminRoutes, ...adminInvoiceRoutes];
    }

    // HONORARIUM
    let honorariumRoutes = [];
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.honorarium") ||
      (hasPermission(rolesData, "admin.honorarium.create") &&
        hasPermission(rolesData, "admin.honorarium.view") &&
        hasPermission(rolesData, "admin.honorarium.update"))
    ) {
      const createRoute = {
        ...adminHonorariumCreateRoutes[0],
        hideInMenu: true,
      };
      const viewRoute = [...adminHonorariumViewRoutes, createRoute];
      honorariumRoutes = [...honorariumRoutes, ...viewRoute];
    } else if (
      hasPermission(rolesData, "admin.honorarium.create") &&
      !hasPermission(rolesData, "admin.honorarium.view")
    ) {
      honorariumRoutes = [...honorariumRoutes, ...adminHonorariumCreateRoutes];
    } else if (
      (hasPermission(rolesData, "admin.honorarium.view") &&
        hasPermission(rolesData, "admin.honorarium.update")) ||
      (hasPermission(rolesData, "admin.honorarium.view") &&
        hasPermission(rolesData, "admin.honorarium.create"))
    ) {
      const createRoute = {
        ...adminHonorariumCreateRoutes[0],
        hideInMenu: true,
      };
      const viewRoute = [...adminHonorariumViewRoutes, createRoute];
      honorariumRoutes = [...honorariumRoutes, ...viewRoute];
    } else if (
      hasPermission(rolesData, "admin.honorarium.view") &&
      !hasPermission(rolesData, "admin.honorarium.create")
    ) {
      honorariumRoutes = [...honorariumRoutes, ...adminHonorariumViewRoutes];
    }

    if (honorariumRoutes.length > 0) {
      adminRoutes = [...adminRoutes, ...honorariumRoutes];
    }

    // CALENDAR ACTIVITY
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.calendar-activity") ||
      hasPermission(rolesData, "admin.calendar-activity.view")
    ) {
      adminRoutes = [...adminRoutes, ...adminCalendarActivityRoutes];
    }

    ///// REPORTS
    let reports = structuredClone(reportsRoutes);
    if (Array.isArray(reports) && reports[0] && !Array.isArray(reports[0].subs)) {
      reports[0].subs = [];
    }

    // REPORT TAX AUTHORITY
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.reports") ||
      hasPermission(rolesData, "admin.reports.tax-authority") ||
      hasPermission(rolesData, "admin.reports.tax-authority.view")
    ) {
      reports[0].subs.push(...adminReportTaxtAuthorityRoutes[0].subs);
      reports.push(adminReportTaxtAuthorityRoutes[1]);
      reports.push(adminReportTaxtAuthorityRoutes[2]);
    }

    // EXPORT SIE
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.reports") ||
      hasPermission(rolesData, "admin.reports.sie")
    ) {
      reports[0].subs.push(...adminSieRoutes[0].subs);
      reports.push(adminSieRoutes[1]);
    }

    // SALARY SHEET
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.reports") ||
      hasPermission(rolesData, "admin.reports.salary-sheet") ||
      hasPermission(rolesData, "admin.reports.salary-sheet.view")
    ) {
      reports[0].subs.push(...adminSalaraySheetRoutes[0].subs);
      reports.push(adminSalaraySheetRoutes[1]);
    }

    // ECONOMIC REPORT
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.reports") ||
      hasPermission(rolesData, "admin.reports.economic-report")
    ) {
      reports[0].subs.push(...adminEconomicReportRoutes[0].subs);
      reports.push(adminEconomicReportRoutes[1]);
    }

    // REPORT SWEDBANK REPORT
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.reports") ||
      hasPermission(rolesData, "admin.reports.swedbank-report") ||
      hasPermission(rolesData, "admin.reports.swedbank-report.view")
    ) {
      reports[0].subs.push(...adminSwedBankReportRoutes[0].subs);
      reports.push(adminSwedBankReportRoutes[1]);
      reports.push(adminSwedBankReportRoutes[2]);
    }

    const uniqueSubsReports = (Array.isArray(reports?.[0]?.subs) ? reports[0].subs : []).filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.path === value.path &&
        t.label === value.label &&
        t.component === value.component &&
        t.hideInMenu === value.hideInMenu
      ))
    );
    if (reports[0]) {
      reports[0].subs = uniqueSubsReports;
    }

    const uniqueArrayReports = reports.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.path === value.path &&
        t.component === value.component &&
        t.hideInMenu === value.hideInMenu
      ))
    );

    reports = uniqueArrayReports;
    if (reports.length > 0) {
      adminRoutes = [...adminRoutes, ...reports];
    }

    //////// SYSTEM
    let systemRoutes = [];

    // ORG
    if (
      hasPermission(rolesData, "system") ||
      hasPermission(rolesData, "system.org") ||
      hasPermission(rolesData, "system.org.view") ||
      hasPermission(rolesData, "system.org.update")
    ) {
      systemRoutes = [...systemRoutes, ...adminOrgViewRoutes];
    }

    // USER
    if (
      hasPermission(rolesData, "system") ||
      hasPermission(rolesData, "system.user") ||
      hasPermission(rolesData, "system.user.view")
    ) {
      systemRoutes = [...systemRoutes, ...adminUserRoutes];
    }

    // SETTINGS DROPDOWN (agrupa Role, Cost Bearer y Accounting)
    let settingsR = structuredClone(settingsRoutes);
    if (Array.isArray(settingsR) && settingsR[0] && !Array.isArray(settingsR[0].subs)) {
      settingsR[0].subs = [];
    }

    // ROLE
    if (
      hasPermission(rolesData, "system") ||
      hasPermission(rolesData, "system.setting") ||
      hasPermission(rolesData, "system.setting.role") ||
      hasPermission(rolesData, "system.setting.role.create") ||
      hasPermission(rolesData, "system.setting.role.update") ||
      hasPermission(rolesData, "system.setting.role.view")
    ) {
      settingsR[0].subs.push({
        path: ADMIN_PATHS.ADMIN_ROLE,
        label: "sidebar.roles",
      });
      settingsR.push(...adminRoleRoutes);
    }

        // COSTBEARER
        if (hasPermission(rolesData, "system") || hasPermission(rolesData, "system.setting") ||hasPermission(rolesData, "system.setting.cost-bearer.view") || hasPermission(rolesData, "system.setting.cost-bearer") || hasPermission(rolesData, "system")) {
            // Sidebar entry hidden: cost bearer is now a tab of the Economic view (the route is still registered for the tab)
            // settingsR[0].subs.push({ path: ADMIN_PATHS.ADMIN_COST_BEARER, label: 'sidebar.costBearer' });
            settingsR.push(...adminCostBearerRoutes);
        }

        // GUIDE
        if (hasPermission(rolesData, "system.setting.guide.view") || hasPermission(rolesData, "system.setting.guide") || hasPermission(rolesData, "system.setting") || hasPermission(rolesData, "system")) {
            settingsR[0].subs.push({ path: ADMIN_PATHS.ADMIN_GUIDE_LIST, label: 'sidebar.guide' });
            settingsR.push(...adminGuideListRoutes);
        }

        // ACCOUNTING
        if (hasPermission(rolesData, "system.account_settings.view") || hasPermission(rolesData, "system.account_settings") || hasPermission(rolesData, "system")) {
            // Sidebar entry hidden: accounting list is now a tab of the Economic view (the route is still registered for the tab)
            // settingsR[0].subs.push({ path: ADMIN_PATHS.ADMIN_ACCOUNTING_LIST, label: 'sidebar.accountingList' });
            settingsR.push(...adminAccountingRoutes);
        }

    // ACCOUNTING
    if (
      hasPermission(rolesData, "system") ||
      hasPermission(rolesData, "system.setting") ||
      hasPermission(rolesData, "system.setting.account-settings.view") ||
      hasPermission(rolesData, "system.setting.account-settings") ||
      hasPermission(rolesData, "system")
    ) {
      // Sidebar entry hidden: accounting list is now a tab of the Economic view (the route is still registered for the tab)
      // settingsR[0].subs.push({
      //   path: ADMIN_PATHS.ADMIN_ACCOUNTING_LIST,
      //   label: "sidebar.accountingList",
      // });
      settingsR.push(...adminAccountingRoutes);
    }

    // ECONOMIC
    if (
      hasPermission(rolesData, "system") ||
      hasPermission(rolesData, "system.setting") ||
      hasPermission(rolesData, "system.setting.economic") ||
      hasPermission(rolesData, "system.setting.economic.view")
    ) {
      settingsR[0].subs.push({
        path: ADMIN_PATHS.ADMIN_ECONOMIC,
        label: "sidebar.economic",
      });
      settingsR.push(...adminEconomicRoutes);
    }

    // INVOICE ACCOUNTS / VAT (tab of the economic view, same permission as the old "Manage VAT" button)
    if (
      hasPermission(rolesData, "admin") ||
      hasPermission(rolesData, "admin.invoice") ||
      hasPermission(rolesData, "admin.invoice.manageVat")
    ) {
      settingsR.push(...adminInvoiceAccountsRoutes);
    }

    // API KEY
    if (
      hasPermission(rolesData, "system") ||
      hasPermission(rolesData, "system.setting") ||
      hasPermission(rolesData, "system.setting.api-key") ||
      hasPermission(rolesData, "system.setting.api-key.view")
    ) {
      settingsR[0].subs.push({
        path: ADMIN_PATHS.ADMIN_API_KEY,
        label: "sidebar.apiKey",
      });
      settingsR.push(...adminApiKeyRoutes);
    }

    const uniqueSubsSettings = (Array.isArray(settingsR?.[0]?.subs) ? settingsR[0].subs : []).filter(
      (value, index, self) =>
        index ===
        self.findIndex((t) => t.path === value.path && t.label === value.label),
    );
    if (settingsR[0]) {
      settingsR[0].subs = uniqueSubsSettings;
    }

    const uniqueArraySettings = settingsR.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.path === value.path &&
            t.component === value.component &&
            t.hideInMenu === value.hideInMenu,
        ),
    );

    settingsR = uniqueArraySettings;

    if (settingsR.length > 1 && Array.isArray(settingsR?.[0]?.subs) && settingsR[0].subs.length > 0) {
      systemRoutes = [...systemRoutes, ...settingsR];
    }

    if (adminRoutes.length > 0) {
      adminRoutes[0].title = "adminLabel.admin";

      if (adminRoutes.length === 1) {
        adminRoutes = adminRoutes.slice(1);
      }
      routes = [...routes, ...adminRoutes];
    }

    if (systemRoutes.length > 0) {
      systemRoutes[0].title = "adminLabel.system";
      routes = [...routes, ...systemRoutes];
    }

        // SUPER ADMIN
        if (CheckUserRole(rolesData, "SuperAdmin")) {
            if (hasPermission(rolesData, "system-admin") || hasPermission(rolesData, "system-admin.open-payment") || hasPermission(rolesData, "system-admin.open-payment.account") || hasPermission(rolesData, "system-admin.open-payment.consent")) {
                routes = [...routes, ...transactionRoutes];
            }
        }
    }

    // useEffect(() => {
    //     console.log('Rutas registradas para guía:', routes);
    //     routes.forEach(route => {
    //         if (!route.path) return;

    //         ApiCall({ method: "get", url: `/guide/${encodeURIComponent(route.path)}` }, (response) => {
    //         if (!response) {
    //             ApiCall({
    //             method: "post",
    //             url: "/guide",
    //             data: { id: route.path, description: route.description || '' }
    //             }, () => {});
    //         }
    //         });

    //         // También registrar subs si los tiene
    //         route.subs?.forEach(sub => {
    //         if (!sub.path) return;
    //         ApiCall({ method: "get", url: `/guide/${encodeURIComponent(sub.path)}` }, (response) => {
    //             if (!response) {
    //             ApiCall({
    //                 method: "post",
    //                 url: "/guide",
    //                 data: { id: sub.path, description: sub.description || '' }
    //             }, () => {});
    //             }
    //         });
    //         });
    //     });
    // }, [isAuthenticated]);

    return routes.map(route => ({
        ...route,
        title: route.title ? t(route.title) : null,
        name: route.name ? t(route.name) : '',
        subs: route.subs ? route.subs.map(sub => ({
            ...sub,
            label: sub.label ? t(sub.label) : ''
        })) : []
    }));
}
